import { Controller } from '@hotwired/stimulus'

// Attached to the actuality form inputs. When the admin picks a project in
// the project select, it pre-fills the "raw_recipients" input with the
// project's default recipients.
export default class AdminActualityRecipientsController extends Controller {
  static targets = ['input', 'projectSelect'];
  static values = { urlTemplate: String };

  connect() {
    this.lastAutofill = '';
  }

  fillRecipients() {
    const projectId = this.projectSelectTarget.value;
    if (!this.hasInputTarget || !projectId) return;

    const url = this.urlTemplateValue.replace('__PROJECT_ID__', projectId);

    fetch(url, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((data) => {
        const current = this.inputTarget.value.trim();

        // Only fill when the field is empty or still holds a previous auto-fill,
        // so we never overwrite addresses the admin typed manually.
        if (current !== '' && current !== this.lastAutofill) return;

        const value = (data.default_actuality_recipients || []).join(', ');
        this.inputTarget.value = value;
        this.lastAutofill = value;
      })
      .catch(() => {});
  }
}
